import type { QueryClient } from '@tanstack/react-query';

import type { UtilityContext } from '@change-corgi/core/react/utilityContext';
import { localStorage } from '@change-corgi/core/storage';

import { findOrCreateDraftAuthorId } from 'src/app/shared/api/petitionDraft';

import type { SapDraftUserDataQuery, SapDraftUserDataQueryVariables } from './api.graphql';
import { SAPDraftUserData } from './api.graphql';

function getExperimentDefaults() {
	return {
		variation: 'control',
		type: 'experiment-service',
		config: {},
		treated: false,
	} as const;
}

type GetDraftUserDataParams = UtilityContext['gql'] & { queryClient: QueryClient };
type GetDraftUserDataResult = SapDraftUserDataQuery & {
	viewer: SapDraftUserDataQuery['viewer'] & { draftAuthorId: string };
};
export async function getDraftUserData({
	fetch,
	queryClient,
}: GetDraftUserDataParams): Promise<GetDraftUserDataResult> {
	try {
		const { data } = await fetch<SapDraftUserDataQuery, SapDraftUserDataQueryVariables>({
			query: SAPDraftUserData,
			rejectOnError: true,
		});

		// get persistent visitor id
		const draftAuthorId = findOrCreateDraftAuthorId({ storage: localStorage, queryClient });

		return { ...data, viewer: { ...data.viewer, draftAuthorId } };
	} catch {
		return {
			experiments: {
				starfishSap3RecommendedAngles: {
					...getExperimentDefaults(),
					experimentName: 'starfish_sap3_recommended_angles',
				},
				starfishPreviewEditExperiment: {
					...getExperimentDefaults(),
					experimentName: 'starfish_preview_edit_experiment',
				},
			},
			viewer: { id: '', uuid: '', user: null, draftAuthorId: '' },
		};
	}
}
